<template>
  <!-- Previous button -->
  <BackButton
    :class="{ 'disabled:cursor-default': configuratorStore.hasMediaclipError }"
    :disabled="
      configuratorStore.isUpdatingProject ||
      configuratorStore.hasMediaclipError ||
      configuratorStore.buttonsOnCooldown
    "
    class="mx-12 w-3/5"
    @click="configuratorStore.previousStep()"
  />

  <div class="col-start-2 flex h-full w-full items-center px-12 lg:col-start-3">
    <template v-if="configuratorStore.showNextButton">
      <!-- Next button (no extra options -->
      <AddToCartButton
        v-if="extraOptionsStore.productOptionsCategories.length === 0"
        :disabled="configuratorStore.disableNextButton"
        :loading="configuratorStore.isUpdatingProject"
        @click="configuratorStore.nextStep(false)"
      />

      <!-- Next button -->
      <DefaultTooltip
        v-else
        :disabled="popperDisabled"
        :content="
          mediaclipStore.emptyWorksheets.length > 0
            ? $tc(
                'pages.configurator.worksheet_container.buttons.next.tooltip.selects_remaining',
                {
                  count: mediaclipStore.emptyWorksheets.length,
                }
              )
            : $tc(
                'pages.configurator.worksheet_container.buttons.next.tooltip.checks_remaining',
                {
                  count:
                    mediaclipStore.amountOfWorksheets -
                    mediaclipStore.filledWorksheets.length,
                }
              )
        "
        class="w-full"
      >
        <DefaultButton
          :class="[
            configuratorStore.hasMediaclipError
              ? 'disabled:cursor-default'
              : mediaclipStore.emptyWorksheets.length
                ? 'disabled:cursor-help'
                : 'disabled:cursor-progress',
          ]"
          :disabled="configuratorStore.disableNextButton"
          :loading="configuratorStore.isUpdatingProject"
          :show-loading-icon="false"
          @click="configuratorStore.nextStep(false)"
        >
          {{ $t('pages.navigation.footer.buttons.next') }}
        </DefaultButton>
      </DefaultTooltip>
    </template>
  </div>
</template>

<script setup lang="ts">
import BackButton from '@/components/Buttons/BackButton.vue';
import { useConfiguratorStore } from '@/stores/Configurator/ConfiguratorStore';
import { useMediaclipStore } from '@/stores/Configurator/MediaclipStore';
import { useExtraOptionsStore } from '@/stores/ExtraOptionsStore';
import { computed } from 'vue';
import AddToCartButton from '../../AddToCartButton.vue';
import DefaultButton from '@/components/Buttons/DefaultButton.vue';
import DefaultTooltip from '@/components/Tooltips/DefaultTooltip.vue';

const extraOptionsStore = useExtraOptionsStore();
const configuratorStore = useConfiguratorStore();
const mediaclipStore = useMediaclipStore();

const popperDisabled = computed(() => {
  return (
    configuratorStore.isUploadConfigurator ||
    mediaclipStore.filledWorksheets.length ===
      mediaclipStore.amountOfWorksheets ||
    mediaclipStore.filledWorksheets.length ===
      mediaclipStore.amountOfWorksheets ||
    mediaclipStore.amountOfWorksheets === 0
  );
});
</script>
